import React, { FC, useState } from "react";
import { useQuery } from "../../../utils";
import { useHistory } from "react-router";
import StatisticsPharmacies from "./StatisticsPharmacies";
import StatisticsPrices from "./StatisticsPrices";


enum StatisticalInventoryTabs {
    statisticsPharmacies = "statisticsPharmacies",
    statisticsPrices = "statisticsPrices",
}


const StatisticsPricesPharmacies: FC = () => {
    const query = useQuery();
    const tabId: string = query.get("statisticalTabId") || StatisticalInventoryTabs.statisticsPharmacies;
    const [activeTab, setActiveTab] = useState<string>(tabId)
    const history = useHistory()

    const getActiveClass = (tab: StatisticalInventoryTabs) => {
        return activeTab === tab ? 'active' : '';
    }
    const getActiveTab = () => {
        switch (activeTab) {
            case StatisticalInventoryTabs.statisticsPharmacies:
                return <StatisticsPharmacies />
            case StatisticalInventoryTabs.statisticsPrices:
                return <StatisticsPrices />
            default:
                <div></div>
        }
    }

    const onSelectTab = (tab: StatisticalInventoryTabs) => {
        history.push(`/admin-dashboard?dashboardTabId=2&statisticalTabId=${tab}`)
        setActiveTab(tab)
    }
    return <div
        style={{ minWidth: "100%" }}
    >
        <div className="upload-flow" >
            <div className="d-flex flex-wrap align-items-center">
                <a href="/#" onClick={
                    (e) => {
                        e.preventDefault();
                        onSelectTab(StatisticalInventoryTabs.statisticsPharmacies)
                    }
                    } className={"upload-tab-title mt-3 mr-3 " + getActiveClass(StatisticalInventoryTabs.statisticsPharmacies)}>
                    Số lượng NT
                </a>
                <a href="/#" onClick={
                    (e) => {
                        e.preventDefault();
                        onSelectTab(StatisticalInventoryTabs.statisticsPrices)
                    }
                    } className={"upload-tab-title mt-3 " + getActiveClass(StatisticalInventoryTabs.statisticsPrices)}>
                    Giá sản phẩm
                </a>
            </div>
            {
                getActiveTab()
            }
        </div>
    </div>
}

export default StatisticsPricesPharmacies;